import img from "../../assets/images/Home/home_posthero_bg.jpg";

const PostHero = () => {
  return (
    <section className="posthero_image_with_text">
      <div className="container container_with_fullWidth">
        <div className="grid">
          <div className="left_con">
            <div className="text_con">
              <h4 className="pre_heading heading_with_line">About Company</h4>
              <h2 className="heading">THE BEGINNING OF AN ERA</h2>
              <p className="para">
                Kalista jewels “THE RING SPECIALIST” make the unique invisible
                setting and is renowned in this refined craftsmanship.The group
                has secured excellent loyalty in Indian market as one of the
                leading designer and Manufacturer of diamond jewellery. Kalista
                Jewel's known for its exclusive designs, quality diamonds . As a
                jeweler, Kalista Jewel's has a monopoly of setting diamonds on
                high end branded steel items like Mobiles, watches and
                accessories. Through these, it has been able to set new
                benchmark in the jewellery industry. Exquisite diamond jewellery
                with excellent workmanship, unique & innovative designs, is the
                strongest trait of the group.
              </p>
            </div>
          </div>
          <div className="right_con">
            <img src={img} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PostHero;
